// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash/fp';
import classNames from 'classnames';

// Utils
import { getNotificationTimestamp } from '../../../../../../../common/notifications/notificationModelUtils';

import humanTime from '../../../../../../../common/utils/lib/humanTime';

// Styles
import './BaseNotificationEntry.scss';

const BaseNotificationEntry = (props) => {
    const { className, children, notification, figure, time } = props;

    const timestamp = getNotificationTimestamp(notification);

    const timeComponent = isUndefined(time) ? (
        <div className="timestamp">{humanTime((Date.now() - timestamp) / 1000)}</div>
    ) : (
        time
    );

    return (
        <li className={classNames('BaseNotificationEntry', className)}>
            <div className="notification-figure">
                <div className="group-connector-cover" />
                {figure}
            </div>
            <div className="notification-body">
                <div className="body-positioner">
                    <div className="notification-details">{children}</div>
                    <div className="notification-time">{timeComponent}</div>
                </div>
            </div>
        </li>
    );
};

BaseNotificationEntry.propTypes = {
    className: PropTypes.string,
    notification: PropTypes.object,
    group: PropTypes.object,
    onClick: PropTypes.func,
    dispatchMarkNotificationAsSeen: PropTypes.func,
    figure: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    time: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default BaseNotificationEntry;
